<template>
  <div>
    <p
      class="q-body-1 text-center"
      v-text="$t('text.myTickets')"
    />
    <q-btn
      v-track-click:button="{category: 'Navegação', label: 'Meus Eventos'}"
      :color="SET_COLOR_BUTTON.primary"
      :text-color="SET_COLOR_BUTTON.text.primary"
      :label="$t('button.myEvents')"
      class="full-width"
      @click="$router.replace(to)"
    />
  </div>
</template>

<script>
  export default {
    name: 'CartMyTickets',
    props: {
      to: {
        type: Object,
        required: true,
      },
    },
  };
</script>
